<div class="daisy-card daisy-card-bordered bg-base-100">
  <div class="daisy-card-title px-6 pt-6">
    <div class="flex flex-wrap">
      <div class="w-full md:w-2/3">
        <h5 class="text-left">
          {{ item.title }}
        </h5>
      </div>
      <div class="w-full md:w-1/3">
        <div class="float-right">
          <button
            class="daisy-btn daisy-btn-sm daisy-btn-error margin-right-1 mb-0"
            href="#"
            (click)="deleteItem(item.id)"
            >
            Delete
          </button>
          <!-- <button class="hollow button small warning mb-0" href="#">Edit</button> -->
        </div>
      </div>
    </div>
  </div>
  <div class="daisy-card-body">
    @if (resourceItem) {
      <p>
        {{ resourceItem.name }} - {{ resourceItem.uploadStatus }}
      </p>
    }
  </div>
</div>
